import getOrientationString from './getOrientationString';
import invertOrientationString from './invertOrientationString';

const orientation = {
  getOrientationString,
  invertOrientationString
};

export default orientation;



// WEBPACK FOOTER //
// ./orientation/index.js